import { appStoreLenses } from 'root/src/client/logic/app/lenses'

const { viewAccountData } = appStoreLenses

export default viewAccountData
